import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=3c4cb1e8&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=3c4cb1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4cb1e8",
  null
  
)

export default component.exports